import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ledning",
  "use": "ledning-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" id=\"ledning\"><path d=\"M1.5 22.45h2.27s-.43-8.79 7.16-10.21h7.79s1.63-.14 1.7-1.56 0-2.55 0-2.55h-1.91V5.86h10V8h-2.14l-.14 3.61S26 17.88 20 17.91h-8.51a2.75 2.75 0 0 0-1.77 2.2c-.14 1.63-.21 2.34-.21 2.34h2.05v2H1.5z\" fill=\"#6d6e71\" stroke=\"#6d6e71\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".43\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ledning.svg
// module id = NF/5
// module chunks = 1